// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button[data-open=true] label[data-v-74c3d81c],
button[data-selected=true] label[data-v-74c3d81c] {

    --tw-translate-y: -24px;

    --tw-translate-x: 4px;

    --tw-scale-x: .75;

    --tw-scale-y: .75;

    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
button[data-open=true] label[data-v-74c3d81c] {

    --tw-text-opacity: 1;

    color: rgb(var(--color-primary) / var(--tw-text-opacity))
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
